module.exports = __webpack_public_path__ + "static/media/phone_body.46be247e.png";